import { createStyles, makeStyles } from '@hawkins/styles';
import { VERTICAL_NAV_COLLAPSED_WIDTH } from './verticalNavigation.styles';
export function navigationMenuGroupStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the element containing the action. */
        actionContainer: {
            marginLeft: 'auto',
        },
        /** Class name of the element containing the component’s children. */
        childrenContainer: {
            display: 'flex',
            gap: hawkinsVariables.spacings.space0,
            // Set margin to 0 in case a `ul` is used as the root element.
            margin: 0,
        },
        /** Class name of the children container when in a horizontal navigation component. */
        childrenContainerHorizontal: {
            alignItems: 'center',
            // Set padding to 0 in case a `ul` is used as the root element.
            padding: 0,
        },
        /** Class name of the children container when in a vertical navigation component. */
        childrenContainerVertical: {
            flexDirection: 'column',
            padding: "0 ".concat(hawkinsVariables.spacings.space2),
        },
        /**
         * Class name of the children container when in a vertical navigation component
         * AND nested within a menu item accordion.
         */
        childrenContainerVerticalNested: {
            padding: 0,
        },
        /** Class name of the label. */
        label: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-Text': { color: hawkins.textColor.textColorXlight },
        },
        /** Class name of the element containing the label. */
        labelContainer: {
            overflowX: 'hidden',
            paddingBottom: hawkinsVariables.spacings.space1,
            paddingRight: hawkinsVariables.spacings.space1,
            paddingTop: hawkinsVariables.spacings.space1,
        },
        /** Class name of the label container when the text is transformed. */
        labelContainerWithTextTransform: {
            textTransform: 'uppercase',
        },
        /** Class name of the element containing the label and action. */
        labelRow: {
            alignItems: 'center',
            display: 'flex',
            minHeight: hawkinsVariables.sizingValues.size3 - 1,
            paddingLeft: hawkinsVariables.spacings.space5,
            paddingRight: hawkinsVariables.spacings.space3,
        },
        /**
         * Class name of the label row when in a vertical navigation component
         * AND nested within a menu item accordion.
         */
        labelRowVerticalNested: {
            paddingLeft: hawkinsVariables.spacings.space2,
            paddingRight: hawkinsVariables.spacings.space0,
        },
        /** Class name of the root element. */
        root: {},
        /** Class name of the root element when in a horizontal navigation component and the overflow menu feature is enabled. */
        rootHorizontalOverflowable: {
            flexGrow: 1,
            // Flex items have `min-width: auto` by default.
            // Need to set `min-width: 0` to support overflow menu functionality (see https://stackoverflow.com/a/36247448).
            minWidth: 0,
        },
        /** Class name of the root element when in a vertical navigation component. */
        rootVertical: {
            display: 'flex',
            flexDirection: 'column',
            gap: hawkinsVariables.spacings.space0,
        },
        /** Class name of the root element when in a collapsed vertical navigation area. */
        rootVerticalCollapsed: {
            width: VERTICAL_NAV_COLLAPSED_WIDTH,
        },
    });
}
export var useNavigationMenuGroupStyles = makeStyles(navigationMenuGroupStyles, {
    name: 'Hawkins-NavigationMenuGroup',
});
